import { AuthState } from '@aws-amplify/ui-components';
import $$api from 'models/api';
import { $global, storage } from 'models/store-global';

import { MyStore } from 'types/Store';

const TermsAndConditionsService = {
    checkIsRelevantSigned: async (role: 'user' | 'advisor') => {
        try {
            let response;
            if ($global.map((state) => state.startAssessment && !state.authData?.credentials).getState()) {
                response = { isRelevantSigned: true };
            } else {
                response = await $$api.termsAndConditions.isRelevantSignedFx(role);
            }
            return response;
        } catch (error: unknown) {
            if (error instanceof Error && JSON.parse(error.message ?? null)?.message === 'Unauthorized') {
                storage.set(
                    (store): MyStore => ({ ...store, auth: { ...(store.auth || {}), authState: AuthState.SignIn } }),
                );
            }
        }
    },
};

export default TermsAndConditionsService;
